import BaseModel from './BaseModel';

/** Class representing a collector stats object. */
class CollectorStats extends BaseModel {}

export default CollectorStats;
